import { Blocks } from 'factories/block';

export const setBlocksLocalAction = (blocks: Blocks) => {
  return {
    type: 'SET_BLOCKS',
    data: blocks,
  };
};
